var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroFacets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 700",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-base",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBF5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0E2C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-r1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D06E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9E2430"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-r2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9E2430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#67141D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-g1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EAD08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C9A227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-g2",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5E8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDB65C"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "url(#h-base)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1200,0 1200,260 960,140",
    fill: "url(#h-r1)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1200,260 1200,520 980,380",
    fill: "url(#h-g1)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "960,140 1200,260 980,380 820,260",
    fill: "url(#h-g2)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "820,260 980,380 900,520 720,420",
    fill: "url(#h-r2)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1200,520 1200,700 980,700 980,380",
    fill: "url(#h-r1)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,700 0,480 220,600 140,700",
    fill: "url(#h-g1)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,480 0,260 180,360 220,600",
    fill: "url(#h-r2)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180,360 0,260 0,80 260,220",
    fill: "url(#h-g2)",
    opacity: 0.45
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 1,
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 140,
    x2: 980,
    y2: 380
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 260,
    x2: 900,
    y2: 520
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 360,
    x2: 220,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 260,
    x2: 260,
    y2: 220
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroFacets);
export default __webpack_public_path__ + "static/media/hero-facets.392d41fb533d3ddc7e36c8c3c9a27ffb.svg";
export { ForwardRef as ReactComponent };